<h1 mat-dialog-title>Upload Image</h1>
<div mat-dialog-content>
  <form [formGroup]="frameworkForm">
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" placeholder="Enter name">
    </mat-form-field>

    <input type="file" (change)="onFileSelected($event)" />
    <div *ngIf="src">
      <img [src]="src" alt="Preview" style="max-width: 100%; margin-top: 10px;" />
    </div>

  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="frameworkForm.invalid || !file">
    Save
  </button>
</div>
